import { AppState } from '../root.reducer';

export const getRepositList = (state: AppState) => state.repositList.results;
export const getRepositListFilters = (state: AppState) => state.repositList.filters;

export const getRepositListPagination = (state: AppState) => ({
  count: state.repositList.count,
  page: state.repositList.page
});
